import { defineComponent as _defineComponent } from 'vue'
import { Icon, Popper } from 'patsnap-biz';

import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/tick.svg';
import '@patsnap-ui/icon/assets/solid/NoDataTip.svg';
import { computed, onMounted, ref } from 'vue';
import _ from 'lodash';

// @ts-ignore
type IOptionItem = {
    label: string;
    tag: string;
    key: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkspaceDropdown',
  props: {
    options: null,
    selectedOption: null,
    disabled: { type: Boolean },
    icon: null,
    openIcon: null,
    closeIcon: null,
    sourceIn: null
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'change', option: IOptionItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    options: IOptionItem[],
    selectedOption: IOptionItem,
    disabled?: boolean,
    icon?: string,
    openIcon?: string,
    closeIcon?: string,
    sourceIn: 'WORKSPACE' | 'ANALYTICS' | 'EUREKA' | 'VOTE',
}

const tippy = Popper.tippy;

const PzIcon = Icon





const dropdownSelect = ref(null)
const dropdownOptions = ref(null)
const tippyInstance = ref(null);

const isShown = computed(() => {
    return _.get(tippyInstance.value, 'state.isShown', false)
})

const onSelect = (option) => {
    if (tippyInstance.value) {
        (tippyInstance.value as any).hide();
    }
    emits('change', option)
}

onMounted(() => {
    tippyInstance.value = tippy(dropdownSelect.value, {
        trigger: 'click',
        interactive: true,
        content: dropdownOptions.value,
        allowHTML: true,
        theme: 'light',
        arrow: false,
        appendTo: () => document.body,
        placement: 'bottom-start',
        offset: props.sourceIn === 'ANALYTICS' ? [0, 8] : [0, 0],
    });
})


return { __sfc: true,tippy, PzIcon, props, emits, dropdownSelect, dropdownOptions, tippyInstance, isShown, onSelect }
}

})